import { copyObject } from '../../../../utils';


import * as _ from 'lodash'
import { invoiceIsDirty,  getVariablesInvoice, lineItemsInvoice } from '../DocumentsTab/Invoice/Invoice';

import { setValueVariables } from '../DocumentsTab/DocumentVariables';
import { InvoiceLineItemT, JobT, RevenueLineItemT } from '../../../../types/Job';
import { InvoiceObj } from '../InitObjectJob';



export const prepareItemsFromRevenue = (lineItems: Array<RevenueLineItemT>) => {
    let items = []
    lineItems.map((item, index) => {
        let itemInvoice: InvoiceLineItemT = {
            item: item.item,
            lineItemDate: item.date ? `${item.date}` : "",
            rate: Number(parseFloat(`${item.rate}`).toFixed(2)),
            units: item.units,
            total: item.total
        }
        items.push(itemInvoice)
    })

    return items;
}

/**
 * 
 */
export const FilterInvoice = {
    callback: (job: JobT): JobT => {
        let cloneJob = copyObject(job)
        let revenue = cloneJob.financial && cloneJob.financial.revenue
        // check if jobStatus is completed or revenue is dirty 
        if (!invoiceIsDirty(cloneJob) && (cloneJob.jobStatus == "completed" || cloneJob.isDateDirty)) {
            let lineItems = copyObject(job.financial.revenue.lineItems)
            let newItemsInvoice = prepareItemsFromRevenue(lineItems)
            let documentsClone = copyObject(cloneJob.documents)
            let invoiceVariables = getVariablesInvoice(cloneJob)
            invoiceVariables = invoiceVariables.length <= 0 ? InvoiceObj.variables : invoiceVariables
            let variables = setValueVariables('lineItems', newItemsInvoice, invoiceVariables, InvoiceObj.variables)
            documentsClone.invoice.variables = variables
            cloneJob.documents = documentsClone

        } else {
            if (!invoiceIsDirty(cloneJob)) {

                const estimateV = lineItemsInvoice(cloneJob, 'estimate')
                let documentsClone = copyObject(cloneJob.documents)
                let invoiceVariables = getVariablesInvoice(cloneJob)
                invoiceVariables = invoiceVariables.length <= 0 ? InvoiceObj.variables : invoiceVariables
                let variables = setValueVariables('lineItems', estimateV, invoiceVariables, InvoiceObj.variables)
                console.log("invoiceLineItems.cloneJob",cloneJob)
                const invoiceLineItems = lineItemsInvoice(cloneJob, 'invoice')
                console.log("invoiceLineItems.variables",InvoiceObj.variables)
                console.log("invoiceLineItems",invoiceLineItems)
                if (!_.isEqual(invoiceLineItems, estimateV)) {
                    documentsClone.invoice.variables = variables
                    cloneJob.documents = documentsClone
                }
            }
        }
        return cloneJob;
    },
    priority: 6,
    name: "documentInvoice"
}
